/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleAdsSuccessfulAccountRuntimeStatus } from './GoogleAdsSuccessfulAccountRuntimeStatus';
import {
    GoogleAdsSuccessfulAccountRuntimeStatusFromJSON,
    GoogleAdsSuccessfulAccountRuntimeStatusFromJSONTyped,
    GoogleAdsSuccessfulAccountRuntimeStatusToJSON,
    GoogleAdsSuccessfulAccountRuntimeStatusToJSONTyped,
} from './GoogleAdsSuccessfulAccountRuntimeStatus';
import type { GoogleAdsUnavailableAccountRuntimeStatus } from './GoogleAdsUnavailableAccountRuntimeStatus';
import {
    GoogleAdsUnavailableAccountRuntimeStatusFromJSON,
    GoogleAdsUnavailableAccountRuntimeStatusFromJSONTyped,
    GoogleAdsUnavailableAccountRuntimeStatusToJSON,
    GoogleAdsUnavailableAccountRuntimeStatusToJSONTyped,
} from './GoogleAdsUnavailableAccountRuntimeStatus';

/**
 * 
 * @export
 * @interface ProjectIntegrationRuntimeStatus
 */
export interface ProjectIntegrationRuntimeStatus {
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    integrationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    integrationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    accountName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    ready?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    phase?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    updateModel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    bootstrapPending?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    lastSuccessfulFetchAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    nextScheduledFetchAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    nextScheduledFetchMode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    activeRunId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    activeRunMode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    activeFetchMode?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    canManualRefresh?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    error?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    errorCode?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    errorMapped?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    attentionCode?: string | null;
    /**
     * Google Ads accounts completed by the correlated fetch.
     * @type {Array<GoogleAdsSuccessfulAccountRuntimeStatus>}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    successfulAccounts?: Array<GoogleAdsSuccessfulAccountRuntimeStatus>;
    /**
     * Google Ads accounts unavailable during or before the correlated fetch.
     * @type {Array<GoogleAdsUnavailableAccountRuntimeStatus>}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    unavailableAccounts?: Array<GoogleAdsUnavailableAccountRuntimeStatus>;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    googleAdsAccountIncidentAt?: string | null;
    /**
     * Google Ads accounts completed in the most recent account-availability incident, exposed for 48 hours.
     * @type {Array<GoogleAdsSuccessfulAccountRuntimeStatus>}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    recentSuccessfulAccounts?: Array<GoogleAdsSuccessfulAccountRuntimeStatus>;
    /**
     * Google Ads accounts unavailable in the most recent account-availability incident, exposed for 48 hours.
     * @type {Array<GoogleAdsUnavailableAccountRuntimeStatus>}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    recentUnavailableAccounts?: Array<GoogleAdsUnavailableAccountRuntimeStatus>;
}

/**
 * Check if a given object implements the ProjectIntegrationRuntimeStatus interface.
 */
export function instanceOfProjectIntegrationRuntimeStatus(value: object): value is ProjectIntegrationRuntimeStatus {
    return true;
}

export function ProjectIntegrationRuntimeStatusFromJSON(json: any): ProjectIntegrationRuntimeStatus {
    return ProjectIntegrationRuntimeStatusFromJSONTyped(json, false);
}

export function ProjectIntegrationRuntimeStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectIntegrationRuntimeStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'integrationId': json['integrationId'] == null ? undefined : json['integrationId'],
        'integrationName': json['integrationName'] == null ? undefined : json['integrationName'],
        'accountName': json['accountName'] === undefined ? undefined : json['accountName'] === null ? null : json['accountName'],
        'ready': json['ready'] == null ? undefined : json['ready'],
        'status': json['status'] == null ? undefined : json['status'],
        'phase': json['phase'] === undefined ? undefined : json['phase'] === null ? null : json['phase'],
        'updateModel': json['updateModel'] == null ? undefined : json['updateModel'],
        'bootstrapPending': json['bootstrapPending'] == null ? undefined : json['bootstrapPending'],
        'lastSuccessfulFetchAt': json['lastSuccessfulFetchAt'] === undefined ? undefined : json['lastSuccessfulFetchAt'] === null ? null : json['lastSuccessfulFetchAt'],
        'nextScheduledFetchAt': json['nextScheduledFetchAt'] === undefined ? undefined : json['nextScheduledFetchAt'] === null ? null : json['nextScheduledFetchAt'],
        'nextScheduledFetchMode': json['nextScheduledFetchMode'] === undefined ? undefined : json['nextScheduledFetchMode'] === null ? null : json['nextScheduledFetchMode'],
        'activeRunId': json['activeRunId'] === undefined ? undefined : json['activeRunId'] === null ? null : json['activeRunId'],
        'activeRunMode': json['activeRunMode'] === undefined ? undefined : json['activeRunMode'] === null ? null : json['activeRunMode'],
        'activeFetchMode': json['activeFetchMode'] === undefined ? undefined : json['activeFetchMode'] === null ? null : json['activeFetchMode'],
        'canManualRefresh': json['canManualRefresh'] == null ? undefined : json['canManualRefresh'],
        'error': json['error'] === undefined ? undefined : json['error'] === null ? null : json['error'],
        'errorCode': json['errorCode'] === undefined ? undefined : json['errorCode'] === null ? null : json['errorCode'],
        'errorMapped': json['errorMapped'] == null ? undefined : json['errorMapped'],
        'attentionCode': json['attentionCode'] === undefined ? undefined : json['attentionCode'] === null ? null : json['attentionCode'],
        'successfulAccounts': json['successfulAccounts'] == null ? undefined : ((json['successfulAccounts'] as Array<any>).map(GoogleAdsSuccessfulAccountRuntimeStatusFromJSON)),
        'unavailableAccounts': json['unavailableAccounts'] == null ? undefined : ((json['unavailableAccounts'] as Array<any>).map(GoogleAdsUnavailableAccountRuntimeStatusFromJSON)),
        'googleAdsAccountIncidentAt': json['googleAdsAccountIncidentAt'] === undefined ? undefined : json['googleAdsAccountIncidentAt'] === null ? null : json['googleAdsAccountIncidentAt'],
        'recentSuccessfulAccounts': json['recentSuccessfulAccounts'] == null ? undefined : ((json['recentSuccessfulAccounts'] as Array<any>).map(GoogleAdsSuccessfulAccountRuntimeStatusFromJSON)),
        'recentUnavailableAccounts': json['recentUnavailableAccounts'] == null ? undefined : ((json['recentUnavailableAccounts'] as Array<any>).map(GoogleAdsUnavailableAccountRuntimeStatusFromJSON)),
    };
}

export function ProjectIntegrationRuntimeStatusToJSON(json: any): ProjectIntegrationRuntimeStatus {
    return ProjectIntegrationRuntimeStatusToJSONTyped(json, false);
}

export function ProjectIntegrationRuntimeStatusToJSONTyped(value?: ProjectIntegrationRuntimeStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'integrationId': value['integrationId'],
        'integrationName': value['integrationName'],
        'accountName': value['accountName'],
        'ready': value['ready'],
        'status': value['status'],
        'phase': value['phase'],
        'updateModel': value['updateModel'],
        'bootstrapPending': value['bootstrapPending'],
        'lastSuccessfulFetchAt': value['lastSuccessfulFetchAt'],
        'nextScheduledFetchAt': value['nextScheduledFetchAt'],
        'nextScheduledFetchMode': value['nextScheduledFetchMode'],
        'activeRunId': value['activeRunId'],
        'activeRunMode': value['activeRunMode'],
        'activeFetchMode': value['activeFetchMode'],
        'canManualRefresh': value['canManualRefresh'],
        'error': value['error'],
        'errorCode': value['errorCode'],
        'errorMapped': value['errorMapped'],
        'attentionCode': value['attentionCode'],
        'successfulAccounts': value['successfulAccounts'] == null ? undefined : ((value['successfulAccounts'] as Array<any>).map(GoogleAdsSuccessfulAccountRuntimeStatusToJSON)),
        'unavailableAccounts': value['unavailableAccounts'] == null ? undefined : ((value['unavailableAccounts'] as Array<any>).map(GoogleAdsUnavailableAccountRuntimeStatusToJSON)),
        'googleAdsAccountIncidentAt': value['googleAdsAccountIncidentAt'],
        'recentSuccessfulAccounts': value['recentSuccessfulAccounts'] == null ? undefined : ((value['recentSuccessfulAccounts'] as Array<any>).map(GoogleAdsSuccessfulAccountRuntimeStatusToJSON)),
        'recentUnavailableAccounts': value['recentUnavailableAccounts'] == null ? undefined : ((value['recentUnavailableAccounts'] as Array<any>).map(GoogleAdsUnavailableAccountRuntimeStatusToJSON)),
    };
}

